import { Pipe, PipeTransform } from '@angular/core';
import { OptionsWithTZ, zonedTimeToUtc } from 'date-fns-tz';

@Pipe({
  name: 'zonedTimeToUtc',
  standalone: true,
})
export class ZonedTimeToUtcPipe implements PipeTransform {
  transform(
    date: string | number | Date,
    timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone,
    options?: OptionsWithTZ | undefined
  ): Date {
    return zonedTimeToUtc(date, timeZone, options);
  }
}
